import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import KLHeader from "../../../components/KLHeader";
import KLPleaseWait from "../../../components/KLPleaseWait";
import { InfoText, Subtitle, Title } from "../../styles";
import { Container } from "./styles";
import { reminderActionsService } from "../../../services/reminderActionsService";
import type { ReminderAction } from "../types";
import {
  priorActionVerbHebrew,
  SERVER_ERROR_MSG,
  TOKEN_ERROR_MSG,
} from "../messages";

type ViewState =
  | { kind: "loading" }
  | { kind: "success" }
  | { kind: "alreadyActed"; priorAction: ReminderAction }
  | { kind: "tokenError" }
  | { kind: "serverError" };

const ConfirmScreen: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<ViewState>({ kind: "loading" });

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setState({ kind: "tokenError" });
      return;
    }
    (async () => {
      try {
        await reminderActionsService.confirm(token);
        if (!cancelled) setState({ kind: "success" });
      } catch (err: any) {
        if (cancelled) return;
        const status = err?.response?.status;
        const data = err?.response?.data;
        if (status === 401) {
          setState({ kind: "tokenError" });
        } else if (status === 409 && data?.prior_action) {
          setState({
            kind: "alreadyActed",
            priorAction: data.prior_action as ReminderAction,
          });
        } else {
          setState({ kind: "serverError" });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <Container>
      <KLHeader />
      {state.kind === "loading" && <KLPleaseWait text="מאשרים את התור" />}
      {state.kind === "success" && (
        <>
          <Title>אישרתם את התור! נתראה בקרוב.</Title>
          <Subtitle>תודה שאישרתם, נשמח לראותכם.</Subtitle>
        </>
      )}
      {state.kind === "alreadyActed" && (
        <>
          <Title>{`כבר ${priorActionVerbHebrew(state.priorAction)} את התור הזה.`}</Title>
        </>
      )}
      {state.kind === "tokenError" && (
        <>
          <Title>{TOKEN_ERROR_MSG}</Title>
          <InfoText>אם קיבלתם את הקישור בטעות, אפשר להתעלם.</InfoText>
        </>
      )}
      {state.kind === "serverError" && (
        <>
          <Title>{SERVER_ERROR_MSG}</Title>
        </>
      )}
    </Container>
  );
};

export default ConfirmScreen;
